import styled from "styled-components/macro";
// import { theme } from "../../theme";
import { motion } from "framer-motion";

export const Container = styled.div``;

export const BlockchainSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  height: 50px;
  border-width: 2px;
  border-color: ${({ theme }) => theme.lightGray};
  border-style: solid;
  margin-bottom: 20px;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  border-radius: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.gray7};

  img {
    display: none;
  }

  @media (min-width: 760px) {
    font-size: 16px;

    img {
      display: flex;
      width: auto;
      height: 25px;
    }
  }
`;

export const NetworksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: auto;
  flex-wrap: wrap;
  padding: 10px;

  @media (min-width: 860px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ModalContent = styled.div`
  text-align: center;
  width: 100%;
`;

export const ModalTitle = styled.h2`
  color: ${({ theme }) => theme.black};
  font-weight: bold;
  font-size: 28px;
  margin: 20px 0;
`;

export const SearchInput = styled.input`
  width: 100%;
  max-width: 400px;
  padding: 10px 15px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.lightGray};
  font-size: 14px;
  outline: none;
  color: ${({ theme }) => theme.black};
  background-color: ${({ theme }) => theme.gray26};
`;

export const NetworksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  justify-content: center;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const NetworkItem = styled(motion.div)`
  background-color: ${({ theme }) => theme.gray26};
  border: 1px solid #3a547a;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    border-color: ${({ theme }) => theme.primary || "#3a547a"};
  }
`;

export const NetworkIcon = styled(motion.img)`
  width: 30px;
  height: 30px;

  @media (min-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const NetworkName = styled(motion.span)`
  color: ${({ theme }) => theme.black};
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
